import React from 'react';
import withIcon from '../utilities/withIcon';

const IconVideoEnd = () => {
  return (
    <g>
      <path d="M14.25 0a.75.75 0 0 1 .75.75v14.5a.75.75 0 1 1-1.5 0V9.268l-11.385 6.63a.752.752 0 0 1-1.008-.237.682.682 0 0 1-.107-.365V.704C1 .315 1.329 0 1.734 0c.134 0 .266.035.38.102L13.5 6.731V.75a.75.75 0 0 1 .75-.75zM2.5 2.062v11.875L12.699 8 2.5 2.062z" />
    </g>
  );
};

export default withIcon(IconVideoEnd);
